import {filter, includes} from 'lodash';

const validUserScopes = [
    'admin',
    'dany_admin',
    'dany_read',
    'fvod_legacy_admin',
    'fvod_legacy_read',
    'ipvod_admin',
    'ipvod_read',
    'ipvod_legacy_admin',
    'ipvod_legacy_read',
    'slingtv_admin',
    'slingtv_read',
];

const filterUserScopes = scopes => filter(scopes, scope => includes(validUserScopes, scope));

export default filterUserScopes;
